/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SFTPDataTypes {
    JOBS = 'jobs',
    RANGES = 'ranges',
    EMPLOYEES = 'employees',
}
